"use client";

import { THEME_BOOT_SCRIPT } from "@/lib/theme";

/** SSR: executable script (no FOUC). Client: data block — no React 19 warning. */
export function ThemeBootScript() {
  return (
    <script
      type={typeof window === "undefined" ? "text/javascript" : "text/plain"}
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: THEME_BOOT_SCRIPT }}
    />
  );
}
